const fileInput = document.querySelector('.feedback__input-file');
const fileLabel = document.querySelector('.placeholder-file');

if (fileInput){
    fileInput.addEventListener('change', function () {
        if (this.files.length > 5) {
            alert('Можно выбрать не более 5 файлов.');
            this.value = '';
            fileLabel.textContent = 'Прикрепите до 5 фото';
        } else if (this.files.length > 0) {
            fileLabel.textContent = `Выбрано файлов: ${this.files.length}`;
        } else {
            fileLabel.textContent = 'Прикрепите до 5 фото';
        }
    });
}
